import { FC } from "react";
import { SanityCta, SanityInfoPage } from "../../graphql-types";
import { cn } from "../lib/helpers";
import CtaButton from "./CtaButton";
import { bodyCopy } from "./InfoPage.module.scss";
import PortableText from "./portableText";
import * as styles from "./Tickets.module.scss";
import TicketsCard from "./TicketsCard";
import TicketsCardPrimo from "./TicketsCardPrimo";
import { bodyTextStyle } from "./typography.module.scss";

export type TicketsPick = Pick<
  SanityInfoPage,
  | "ticketsCopy"
  | "ticketsCards"
  | "ticketsCardSpectator"
  | "ticketsCardPrimo"
  | "primoTicketHidden"
>;

export interface TicketsProps extends TicketsPick {
  ticketsBuyCta: SanityCta;
}

const Tickets: FC<TicketsProps> = ({
  ticketsCopy,
  ticketsCards,
  ticketsBuyCta,
  ticketsCardSpectator,
  ticketsCardPrimo,
  primoTicketHidden,
}) => {
  return (
    <div id="tickets">
      <div className={cn(bodyTextStyle, bodyCopy)}>
        <PortableText blocks={ticketsCopy} />
      </div>
      <div className={styles.ticketsCards}>
        {ticketsCards.map((card, index) => (
          <TicketsCard key={index} {...card} />
        ))}
        {!primoTicketHidden && (
          <TicketsCardPrimo
            {...ticketsCardPrimo}
            className={styles.ticketsPrimoCard}
          />
        )}
        <CtaButton
          label={ticketsBuyCta.label}
          url={ticketsBuyCta.url}
          theme="orange"
          className={styles.ticketsCta}
          size="large"
        />
        <TicketsCard
          {...ticketsCardSpectator}
          className={styles.ticketsSpectateCard}
        />
      </div>
    </div>
  );
};

export default Tickets;
